import React from 'react';
import { BoxIcon } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  icon?: BoxIcon;
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'md',
  icon: Icon,
  children,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-mono font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#0a1628] disabled:opacity-50 disabled:cursor-not-allowed uppercase tracking-wider clip-path-slant';
  const variants = {
    primary: 'bg-[#00d4ff] text-[#0a1628] hover:bg-[#4de3ff] hover:shadow-[0_0_15px_rgba(0,212,255,0.5)] border border-transparent',
    secondary: 'bg-[#1a2942] text-[#00d4ff] border border-[#00d4ff]/30 hover:border-[#00d4ff] hover:bg-[#00d4ff]/10',
    outline: 'bg-transparent text-slate-300 border border-slate-600 hover:border-slate-400 hover:text-white',
    danger: 'bg-red-500/10 text-red-500 border border-red-500/50 hover:bg-red-500/20 hover:border-red-500 hover:shadow-[0_0_15px_rgba(239,68,68,0.3)]'
  };
  const sizes = {
    sm: 'text-xs px-3 py-1.5 gap-1.5',
    md: 'text-sm px-5 py-2.5 gap-2',
    lg: 'text-base px-8 py-3.5 gap-2.5'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-218">
      {Icon && <Icon className="w-4 h-4" data-id="element-219" />}
      {children}
    </button>;
}